import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { VOUCHER_STATUS } from '@app/constant/VoucherConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import { toRemainingTime } from '@app/libs/format'
import { InertiaLink, usePage } from '@inertiajs/inertia-react'

import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export default function CampaignVouchers() {
  const {
    props: { campaign, vouchers },
  } = usePage()

  const { t } = useTranslation()

  return (
    <Section>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant="h5">{t('CAMPAIGN.LIST_VOUCHER')} </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DataGrid
                enableIndexColumn
                columns={[
                  {
                    id: 'name',
                    Header: t('VOUCHER.NAME'),
                    accessor: 'name',
                    type: 'string',
                  },

                  {
                    id: 'total_cost',
                    Header: t('VOUCHER.COST'),
                    accessor: 'total_cost',
                    type: 'number',
                    autoHide: true,
                  },
                  {
                    id: 'codes_count',
                    Header: t('VOUCHER.TOTAL_CODES'),
                    accessor: 'codes_count',
                    type: 'number',
                    autoHide: true,
                  },
                  {
                    id: 'redeemed_codes',
                    Header: t('VOUCHER.REDEEMED_CODE'),
                    accessor: 'redeemed_codes',
                    type: 'number',
                    autoHide: true,
                  },
                  {
                    id: 'used_codes',
                    Header: t('VOUCHER.USED_CODE'),
                    accessor: 'used_codes',
                    type: 'number',
                    autoHide: true,
                  },

                  {
                    id: 'expired_date',
                    Header: t('VOUCHER.EXPIRED'),
                    accessor: 'expired_date',
                    type: 'dateTime',
                    disableFilters: true,
                  },

                  {
                    id: 'remain_time',
                    Header: t('VOUCHER.REMAIN_TIME'),
                    accessor: ({ expired_date }) => ({ expired_date }),
                    type: 'dateTime',
                    disableFilters: true,
                    disableSortBy: true,
                    Cell: ({ row }) => <>{toRemainingTime(new Date(), row.original.expired_date)}</>,
                  },

                  {
                    id: 'merchant_name',
                    Header: t('VOUCHER.MERCHANT_NAME'),
                    accessor: 'merchant_name',
                    type: 'string',
                    autoHide: true,
                  },
                  {
                    id: 'type',
                    Header: t('VOUCHER.VOUCHER_TYPE'),
                    accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
                    type: 'singleSelect',
                    typeCategories: 'Type',
                    options: [
                      { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                      { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
                    ],
                  },
                  {
                    id: 'status',
                    Header: t('VOUCHER.STATUS'),
                    accessor: ({ status }) => t(`CODES.${status.toUpperCase()}`),
                    type: 'singleSelect',
                    options: [
                      { value: VOUCHER_STATUS.ACTIVE, name: t('VOUCHERS.ACTIVE') },
                      { value: VOUCHER_STATUS.IN_ACTIVE, name: t('VOUCHERS.INACTIVE') },
                    ],
                  },
                  {
                    id: 'actions',
                    Header: t('VOUCHER.ACTION'),
                    disableFilters: true,
                    align: 'center',
                    cell: {
                      style: { whiteSpace: 'nowrap' },
                    },
                    Cell: ({ row }) => (
                      <IconButton component={InertiaLink} href={route('partner.vouchers', row.original.id)}>
                        <PageviewIcon />
                      </IconButton>
                    ),
                  },
                ]}
                data={vouchers}
                enableCollapseFilter={false}
                queries={{ campaign }}
                routeName="partner.campaigns.show"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Section>
  )
}
